"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IF = void 0;
exports.IF = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 3, max: 3 },
    },
    evaluate: (inputs) => {
        const [condition, trueResult, falseResult] = inputs;
        // Array handling for condition input
        if (Array.isArray(condition)) {
            // Validate result size if arrays are provided
            if (Array.isArray(trueResult) && trueResult.length !== condition.length) {
                return {
                    error: 'Array evaluations must return results with the same array lengths',
                };
            }
            if (Array.isArray(falseResult) &&
                falseResult.length !== condition.length) {
                return {
                    error: 'Array evaluations must return results with the same array lengths',
                };
            }
            const result = condition.map((element, idx) => {
                if (Boolean(element) === true) {
                    return Array.isArray(trueResult) ? trueResult[idx] : trueResult;
                }
                return Array.isArray(falseResult) ? falseResult[idx] : falseResult;
            });
            return { error: null, result };
        }
        if (Boolean(condition) === true) {
            return { error: null, result: trueResult };
        }
        return { error: null, result: falseResult };
    },
};
//# sourceMappingURL=if.js.map